import React from 'react';
import { useTranslation } from '@lt/localization';
import { EmptyReviews as EmptyReviewsIcon } from '@lt/components/icons-react/userflow';

import { ButtonTs } from '@lt/components';
import styles from './errorBanner.module.css';

interface ErrorBannerProps {
  onClickRetry: () => void;
}

const ErrorBanner = ({ onClickRetry }: ErrorBannerProps) => {
  const { t } = useTranslation();
  const handleClick = () => {
    onClickRetry();
  };
  return (
    <div className={styles.errorBanner}>
      <EmptyReviewsIcon width={165} />
      <div className={styles.title}>{t('hotel.reviews.error.title')}</div>
      <div className={styles.subTitle}>{t('hotel.reviews.error.subTitle')}</div>
      <ButtonTs
        onClick={handleClick}
        variant="primary"
        className={styles.button}
        size="large"
      >
        {t('hotel.reviews.error.button')}
      </ButtonTs>
    </div>
  );
};

export default ErrorBanner;
